import api from 'apiConfig/axiosConfig';
import * as actionTypes from './quotesActionTypes';
import { 
    QuotesModel
} from './quotesStateModel';


//Default
export const fetchingQuotes = (status: boolean) => {
    return {
        type: actionTypes.FETCHING_QUOTES,
        payload: status
    }
}


//Success
export const buildQuotesSuccess = (quotes: QuotesModel[]) => {
    return {
        type: actionTypes.BUILD_QUOTE_SUCCESS,
        payload: quotes
    }
}


//Failure
export const buildQuotesFailure = (quotesErrorMessage: string) => {
    return {
        type: actionTypes.BUILD_QUOTE_FAILURE,
        payload: quotesErrorMessage
    }
}

//Triggers
export const buildQuotesAsync = (mpan: string, loa: File, startDate: string, endDate: string) => {
    return dispatch => {
        dispatch(fetchingQuotes(true));
        dispatch(buildQuotesFailure(""));

        const formData = new FormData();

        formData.append('loa', loa);
        api.post('/quotes', formData, {
            params: {
                mpan, startDate, endDate
            },
            headers: {
                'content-type': 'multipart/form-data'
            }
        })
        .then(response => {
            const res: QuotesModel[] = response.data;

            dispatch(buildQuotesSuccess(res));
            dispatch(fetchingQuotes(false));
            dispatch(buildQuotesFailure(""));
        })
        .catch(error => {
            dispatch(fetchingQuotes(false));
        })
    }
}


//Bundle and export all auth actions
export const quotesActionTriggers = {
    buildQuotesAsync: (mpan: string, loa: File, startDate: string, endDate: string) => buildQuotesAsync(mpan, loa, startDate, endDate),
    buildQuotesFailure: (quotesErrorMessage: string) => buildQuotesFailure(quotesErrorMessage),
    buildQuotesSuccess: (quotes: QuotesModel[]) => buildQuotesSuccess(quotes)
};